/* eslint-disable no-bitwise */

import { useState, useEffect } from 'react';
import { Target } from 'generated/maya.types';

const useMiViewTargetAccordion = (target: Target, opened: boolean) => {
  const [personInitials, setPersonInitials] = useState('');
  const [readableColor, setReadableColor] = useState('');
  const [openedState, setOpenedState] = useState(opened);

  const generateReadableColor = (id: string) => {
    let hash = 0;

    id.split('').forEach((char) => {
      hash = char.charCodeAt(0) + ((hash << 5) - hash);
      hash &= hash;
    });

    const r = (hash >> 16) & 0xff;
    const g = (hash >> 8) & 0xff;
    const b = hash & 0xff;

    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    const adjust = brightness < 150 ? 100 : -100;

    const adjustColor = (c: number) => Math.min(255, Math.max(0, c + adjust));
    const finalR = adjustColor(r);
    const finalG = adjustColor(g);
    const finalB = adjustColor(b);

    return `rgb(${finalR}, ${finalG}, ${finalB})`;
  };

  const getFullname = () => {
    if (target.firstName && target.lastName) {
      return `${target?.lastName || '-'}, ${target?.firstName || '-'}`;
    }

    return '';
  };

  const changeOpenState = () => {
    setOpenedState(!openedState);
  };

  useEffect(() => {
    setReadableColor(generateReadableColor(target?.mdmId));
  }, [target]);

  useEffect(() => {
    if (target?.firstName || target?.lastName) {
      setPersonInitials(`${target?.firstName?.[0] || ''} ${target?.lastName?.[0] || ''}`);
    }
  }, [target]);

  useEffect(() => {
    setOpenedState(opened);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opened]);

  return {
    personInitials,
    readableColor,
    openedState,
    changeOpenState,
    getFullname,
  };
};

export default useMiViewTargetAccordion;
